import serverCall from "../../serverCall";

const addRace = async (data) => {
  const response = await serverCall.post("/race/create/admin", data);
  return response;
};

const GetRace = async (status, page, data, type) => {
  let response = null;
  if (status === "--" || status === null || status === "") {
    response = await serverCall.get(
      `/race/find-all/admin?page=${page === undefined ? 1 : page}&limit=${12}&type=${type}`,
      data
    );
  } else if (
    status === "active" ||
    status === "inactive" ||
    status === "finished"
  ) {
    response = await serverCall.get(
      `/race/find-all/admin?raceStatus=${status}&page=${
        page === undefined ? 1 : page
      }&limit=${12}&type=${type}`,
      data
    );
  }
  return response;
};

const raceResult = async (data) => {
  let response = await serverCall.post("/result/admin", data);
  return response;
};

const raceAllResult = async (id, page, limit, search, type) => {
  let response = await serverCall.get(
    `/result/find-one/v1?raceId=${id}&page=${
      page === undefined ? 1 : page
    }&limit=${limit}&search=${search}&type=${type}`
  );
  return response;
};

const raceResultDelete = async (id, name) => {
  let response;
  if (name === "single") {
    response = await serverCall.delete(`/result/admin?resultId=${id}`);
  } else {
    response = await serverCall.delete(`/result/admin?raceId=${id}`);
  }
  return response;
};

const GetSingleRace = async (id) => {
  const response = await serverCall.get(`/race/find-one/admin?raceId=${id}`);
  return response;
};

const UpdateRace = async (id, status) => {
  const response = await serverCall.put(
    `/race/update-status/admin?raceId=${id}&raceStatus=${status}`
  );
  return response;
};

const UpdateRacing = async (id, data) => {
  const response = await serverCall.put(
    `/race/updated/admin?raceId=${id}`,
    data
  );
  return response;
};

const PredictionList = async (status, page, limit) => {
  const response = await serverCall.get(
    `/predict/find-users-predication/admin?raceId=${status}&page=${page}&limit=${limit}`
  );
  return response;
};

const DownloadPredictionList = async (id) => {
  const response = await serverCall.get(
    `/predict/find-users-predication/admin?raceId=${id}`
  );
  return response;
};

const DeleteRace = async (id) => {
  const response = await serverCall.delete(`/race/delete/admin?raceId=${id}`);
  return response;
};
const UpdateResult = async (id) => {
  const response = await serverCall.get(
    `/result/find-one/admin?resultId=${id}`
  );
  return response;
};
const getSingleResult = async (id, data) => {
  const response = await serverCall.patch(
    `/result/update/admin?resultId=${id}`,
    data
  );
  return response;
};

const deletePlayerFromRace = async (raceId, playerId) => {
  const response = await serverCall.post(
    `/race/remove-player/admin?raceId=${raceId}&playerId=${playerId}`
  );
  return response;
};

const addPlayerToRace = async (data) => {
  const response = await serverCall.post("/race/add-player/admin", data);
  return response;
};

const RaceService = {
  addRace,
  GetRace,
  deletePlayerFromRace,
  GetSingleRace,
  DeleteRace,
  addPlayerToRace,
  UpdateRace,
  PredictionList,
  UpdateRacing,
  raceResult,
  raceResultDelete,
  raceAllResult,
  UpdateResult,
  getSingleResult,
  DownloadPredictionList,
};

export default RaceService;
